





















import { Vue, Component, Watch } from 'vue-property-decorator';
import * as config from './config';
import { detail, getBaseInfo } from './api/index';
import SyPlayer from '@/components/SyPlayer.vue';
import {
  Popup,
  Button,
  Swipe,
  SwipeItem,
  Icon,
  ImagePreview,
  Toast,
} from 'vant';
import { Banner } from '@/components';
import VoteButton from './components/VoteButton.vue';
Vue.use(Swipe).use(SwipeItem);
Vue.use(Popup).use(Button);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(ImagePreview);

@Component({
  components: {
    SyPlayer,
    VoteButton,
  },
})
export default class Detail extends Vue {
  option = config.OPTHINES;
  votetime: any = '';
  baseInfo: any = {};
  ifvote = false;
  detailData: any = {};
  detailVideo = '';
  detailCover = [];
  source: any = '';
  videoClass = '';
  VideoNum = 0;
  nowtime: any = '';
  show: boolean = false;
  titleImage: any[] = [];
  imgInstance: any = '';
  created() {
    this.fetchDetail();
    this.getTime();
    getBaseInfo().then((res: any) => {
      this.baseInfo = res.data;
    });
  }
  backRoute() {
    if (window.history.length <= 1) {
      this.$router.push('List');
    } else {
      this.$router.go(-1);
    }
  }
  votSuccess(data: string | number) {
    this.detailData.votes = data;
  }
  async fetchDetail() {
    const res = await detail(this.$route.query.id);
    this.detailData = res.data;
    this.detailVideo = this.detailData.video;
    this.detailCover = this.detailData.cover;
    this.source = this.$route.query.source;
  }
    // 显示图片
  handlePicShow(index: number) {
    this.imgInstance = ImagePreview({
      images: this.detailCover,
      startPosition: index,
      closeable: true,
    });
  }
  beforeRouteLeave(to: any, from: any, next: any) {
    if (this.imgInstance && this.imgInstance.close) {
      this.imgInstance.close();
    }
    next();
  }
  getTime() {
    setInterval( () => {
      this.nowtime = new Date();
      this.nowtime = Date.parse(this.nowtime) / 1000;
      this.votetime = this.baseInfo.startTime;
      if (this.nowtime > this.votetime) {
        this.ifvote = true;
      } else {
        this.ifvote = false;
      }
    }, 1000);
  }
}

